import { useEffect, useState } from "react";
import { doc, onSnapshot } from "firebase/firestore";
import { RequestFormSettingsSchema, paths } from "@clevis/shared-types";
import { db } from "../lib/firebase";

/** The company's lead sources (Setup → Lead sources; also the website form's "how did you hear"). */
export function useLeadSources(tenantId: string | null): string[] {
  const [sources, setSources] = useState<string[]>([]);
  useEffect(() => {
    if (!tenantId) return;
    return onSnapshot(
      doc(db, paths.tenantRequestFormSettings(tenantId)),
      (snap) => setSources(RequestFormSettingsSchema.parse(snap.data() ?? {}).howHeardOptions),
      () => undefined,
    );
  }, [tenantId]);
  return sources;
}
